export const tr = {
    'be-sure-no-error': 'Bu sayfayı görüntüleme yetkiniz yok',
    title: 'Sayfaya erişilemiyor'
};
